import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { ToastStyled } from '../components';
import { redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const useDeleteAccount = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async () => {
      const res = await fetch(`/user/delete`, {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
        credentials: 'include',
      });

      if (!res.ok) {
        throw new Error('Failed to delete cart');
      }

      const { status } = await res.json();

      // since status is an empty string if successful, we can check
      // to see if status exists, if it does, it means there was an error
      if (status) {
        throw new Error('Error updating cart... status...');
      }

      return true;
    },
    onSuccess: () => {
      queryClient.setQueryData(['currentUser'], null);
      redirect(`/`);
    },
    onError: () => {
      toast.custom((toastBlock) => (
        <ToastStyled
          variant='error'
          handleClose={() => toast.dismiss(toastBlock)}
        >
          {t('my_account.something_went_wrong_while_deleting_your_account')}
        </ToastStyled>
      ));
    },
  });
};
